/**
 * LeftPanelHeader - Header for the left control panel
 *
 * Displays the GeoTIFF Viewer title and current layer badge.
 */

import React from 'react';

interface LeftPanelHeaderProps {
  selectedLayer: string;
}

export function LeftPanelHeader({ selectedLayer }: LeftPanelHeaderProps) {
  return (
    <div className="p-6 border-b-4 border-[#EBFD03]">
      <div className="flex items-center justify-between mb-2">
        <h1 className="text-3xl font-bold text-black">GeoTIFF Viewer</h1>
        <span className="px-3 py-1 bg-gray-100 border-2 border-black rounded-lg text-sm font-bold uppercase">
          {selectedLayer}
        </span>
      </div>
      <p className="text-sm text-gray-600">
        Leaflet map with GeoTIFF overlay
      </p>
    </div>
  );
}

export default LeftPanelHeader;
